/**
 * Retrieves query string from address bar.
 */
export function getQueryString() {
	const { href } = window.location;
	let queryString = href.split('?')[1];
	queryString = typeof queryString !== 'undefined' ? unescape(queryString) : '';
	return queryString;
}

/**
 * Searchings Querystring for parameter and outputs value.
 * @param {string} name Name of Parameter to search.
 */
export function getQueryStringParam(name, initialQueryString = '') {
	if (!name.length) {
		console.error('Error', 'Parameter \'name\' not found in getQueryStringParam');
		return '';
	}
	const regex = new RegExp(`${name}(=([^&#]*)|&|#|$)`);
	let results = regex.exec(initialQueryString);
	results = results !== null ? results[2] : '';
	return results;
}

/**
 * Sets query string to the url via pushState.
 */
export function setQueryString(terms, page = 1) {
	const { href } = window.location;
	const cp = page > 1 ? `&cp=${page}` : '';

	let termString = '';
	if (terms.length) {
		terms.forEach((term) => {
			termString = `${termString},${term}`;
		});
		termString = (termString.length && termString[0] === ',') ? termString.slice(1) : termString;
	}

	/** Setting Query string with accounting for no current_page paramenter if on the first page */
	let queryString = `${cp}`;
	if (termString.length) {
		queryString = `${queryString}&terms=${termString}`;
	}

	if (queryString.charAt(0) === '&') {
		queryString = queryString.substring(1);
	}
	queryString = queryString.length ? `?${escape(queryString)}` : '';

	let path = href.split('?')[0];
	path = typeof path !== 'undefined' ? `${path}${queryString}` : `${href}${queryString}`;

	window.history.pushState({}, '', path);
	return true;
}
